import { action, makeAutoObservable, observable } from 'mobx';
import { validateLength } from 'src/api/utils/form2Validators';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { FormModel } from 'src_common/common/mobx-utils/Form2/FormModel';
import { validateNotEmpty } from 'src_common/common/mobx-utils/Form2/validators';

export type SeoPageTranslationFormType = {
    short_description: null | undefined | string;
    full_description: null | undefined | string;
    title: null | undefined | string;
    language: string;
};

export class SeoPageTranslationFormState {
    @observable public isNewForm: boolean = true;
    @observable public isDuplicatedForm: boolean = true;
    @observable public readonly language: FormInputState<string, string>;
    @observable public readonly title: FormInputState<string, string>;
    @observable public readonly shortDescription: FormInputState<string, string>;
    @observable public readonly fullDescription: FormInputState<string, string>;
    @observable private readonly form: FormModel<SeoPageTranslationFormType>;

    public constructor() {
        this.language = FormInputState.new('').map(validateNotEmpty('Please choose a language'));
        this.title = FormInputState.new('').map(validateLength(100));
        this.shortDescription = FormInputState.new('').map(validateLength(1000));
        this.fullDescription = FormInputState.new('').map(validateLength(10000));

        this.form = FormModel.group({
            language: this.language,
            title: this.title,
            short_description: this.shortDescription,
            full_description: this.fullDescription,
        });
        makeAutoObservable(this);
    }

    public getFormValue = (): SeoPageTranslationFormType | null => {
        this.form.setAsVisited();
        const { result } = this.form;

        if (result.value.type === 'ok') {
            return {
                ...result.value.data,
            };
        }
        return null;
    };

    @action public resetForm = (): void => {
        this.form.reset();
    };
}
